import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  addCode({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`redeem/insertRedeem`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },


  findList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`redeem/selectRedeemList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`redeem/selectRedeemInfo`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`redeem/updateRedeem`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findCodeList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`redeem/selectNumberList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateCodeData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`redeem/updateRedeemNumberInfo`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  exportData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`redeem/exportRedeemNumData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  exportRedeemData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`redeem/exportRedeemData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  loseEffect({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`redeem/loseEffect`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

}
